import {HttpParams} from '@angular/common/http';
import {Injectable, Injector} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {BaseDaoService} from '@q9elements/ui-kit/common';
import {
  CustomNodeAttributeInterface,
  FieldDependenciesInterface
} from '@q9elements/ui-kit/refmodels';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export abstract class RmeNodeDaoAbstractService extends BaseDaoService {
  protected constructor(
    protected translate: TranslateService,
    protected injector: Injector
  ) {
    super();
  }

  public getNode(refModelId: string, nodeId: string): Observable<any> {
    const url = `${this.apiUrl}/refmodel/${refModelId}/node/${nodeId}`;
    return this.http.get(url);
  }

  public getNodesByParent(
    refModelId: string,
    parentId: string,
    query: {skip: number; limit: number}
  ): Observable<any> {
    const params = new HttpParams()
      .set('skip', String(query.skip))
      .set('limit', String(query.limit));
    const url = `${this.apiUrl}/refmodel/${refModelId}/node/${parentId}/children`;

    return this.http.get(url, {params});
  }

  public updateNode(refModelId: string, nodeId: string, updateObj: any): Observable<any> {
    const url = `${this.apiUrl}/refmodel/${refModelId}/node/${nodeId}`;

    return this.http.put(url, updateObj);
  }

  public deleteNode(refModelId: string, nodeId: string, internalNode: boolean): Observable<any> {
    const url = `${this.apiUrl}/refmodel/${refModelId}/node/${nodeId}${internalNode ? '/internal' : ''}`;

    return this.http.delete(url);
  }

  public addNewNode(refModelId: string, data: any): Observable<any> {
    const url = `${this.apiUrl}/refmodel/${refModelId}/node`;

    return this.http.post(url, data);
  }

  public getUnassessedChildrenCount(
    refmodelId: string,
    nodeId: string,
    queryParams: any
  ): Observable<any> {
    const url = `${this.apiUrl}/refmodel/${refmodelId}/node/${nodeId}/gdpr`;

    return this.http.get(url, {params: queryParams});
  }

  public updateChildrenGDPR(
    refmodelId: string,
    nodeId: string,
    updateObject: any
  ): Observable<any> {
    const url = `${this.apiUrl}/refmodel/${refmodelId}/node/${nodeId}/children`;

    return this.http.put(url, updateObject);
  }

  public addProposedNode(refModelId: string, data: any): Observable<any> {
    const url = `${this.apiUrl}/refmodel/${refModelId}/proposed`;

    return this.http.post(url, data);
  }

  public getCustomNodeAttributesByNodes(
    refModelId: string,
    nodeIds: string[]
  ): Observable<CustomNodeAttributeInterface[]> {
    const url = `${this.apiUrl}/refmodel/${refModelId}/nodes/custom-node-attributes`;
    return this.http.post<CustomNodeAttributeInterface[]>(url, {nodes: nodeIds});
  }

  public getCustomFieldDependencies(
    implementationId: string
  ): Observable<FieldDependenciesInterface[]> {
    const url = `${this.apiUrl}/customisations/implementation/${implementationId}/field-dependency-maps`;
    return this.http.get<FieldDependenciesInterface[]>(url);
  }
}
